export default value => {
  var arr = value.split('/')
  return arr[0].trim()
}
